import { render, staticRenderFns } from "./RestrictedCommonArticleItem.vue?vue&type=template&id=69d122d0&"
import script from "./RestrictedCommonArticleItem.vue?vue&type=script&lang=js&"
export * from "./RestrictedCommonArticleItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports